var map = {
  "./cs.json": [
    "lnM",
    [
      "rp"
    ]
  ],
  "./en.json": [
    "OnM",
    [
      "ke"
    ]
  ],
  "./pl.json": [
    "jPJ",
    [
      "pj2"
    ]
  ],
  "./ru.json": [
    "M5z",
    [
      "ai"
    ]
  ],
  "./tr.json": [
    "JaX",
    [
      "bsc"
    ]
  ],
  "./ja.json": [
    "vB",
    [
      "9s3"
    ]
  ],
  "./zh.json": [
    "rK",
    [
      "9mp"
    ]
  ],
  "./pt-br.json": [
    "vLg",
    [
      "xu9"
    ]
  ],
  "./de.json": [
    "SN",
    [
      "0o"
    ]
  ],
  "./es.json": [
    "HmC",
    [
      "d1f"
    ]
  ],
  "./fr.json": [
    "ZZ5",
    [
      "zt"
    ]
  ],
  "./it.json": [
    "p5",
    [
      "bq"
    ]
  ],
  "./ko.json": [
    "SV",
    [
      "gk"
    ]
  ],
  "./pt.json": [
    "DQ",
    [
      "hf"
    ]
  ]
};
function __rspack_async_context(req) {
  if(!__webpack_require__.o(map, req)) {
    return Promise.resolve().then(() => {
var e = new Error("Cannot find module '" + req + "'");
e.code = 'MODULE_NOT_FOUND';
throw e;
});
  }

  var ids = map[req], id = ids[0];
  return __webpack_require__.e(ids[1][0]).then(() => (__webpack_require__.t(id, 3 | 16)));
}

__rspack_async_context.keys = () => (Object.keys(map));
__rspack_async_context.id = "wy8";
module.exports = __rspack_async_context;
